/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { entitiesDelete } from "../../funcs/entitiesDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteInstructionRequest$inboundSchema,
};

export const tool$entitiesDelete: ToolDefinition<typeof args> = {
  name: "entities-delete",
  description: `Delete Instruction

Delete an instruction. This will delete the instruction and all entities generated by it. This operation is irreversible.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await entitiesDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
